import { combineReducers } from "@reduxjs/toolkit";

import BulkPublishingReducer from "./bulkPublishing/bulkPublishing";
import ClientDashboardReducer from "./clientDashboard/clientDashboard";
import BankStatementDocumentsReducer from "./clientSettings/bankStatementDocuments/bankStatementDocuments";

import ConnectionsSettingsReducer from "./clientSettings/connections/connections";
import emailForwardingSendersReducer from "./clientSettings/emailForwardingSenders/emailForwardingSenders";
import TeamSettingsReducer from "./clientSettings/team/team";
import CommentParsingReducer from "./commentParsing/commentParsing";
import CommunicationsHubReducer from "./communicationsHub/communicationsHub";
import CompanysReducer from "./companies/companies";
import CompanyDashboardReducer from "./companyDashboard/companyDashboard";
import CompanyDetailsReducer from "./companyDetails/companyDetails";

import CompanyMembersReducer from "./companyMembers/companyMembers";
import DocumentStatusReducer from "./documentsUpload/status/documentUploadStatus";
import DocumentIngestReducer from "./documentsUpload/upload/documentsUpload";
import LineItemExtractionReducer from "./lineItemExtraction/lineItemExtraction";
import OperatorReducer from "./operator/operator";
import ReconciliationReducer from "./reconciliation/reconciliation";
import TransactionsReducer from "./transactions/transactions";

const featuresReducer = combineReducers({
  Companys: CompanysReducer,
  ClientDashboard: ClientDashboardReducer,
  CompanyDashboard: CompanyDashboardReducer,
  transactions: TransactionsReducer,
  BulkPublishing: BulkPublishingReducer,
  CompanyDetails: CompanyDetailsReducer,
  CompanyMembers: CompanyMembersReducer,
  TeamSettings: TeamSettingsReducer,
  ConnectionsSettings: ConnectionsSettingsReducer,
  DocumentIngest: DocumentIngestReducer,
  DocumentStatus: DocumentStatusReducer,
  emailForwardingSenders: emailForwardingSendersReducer,
  BankStatementDocuments: BankStatementDocumentsReducer,
  LineItemExtraction: LineItemExtractionReducer,
  operator: OperatorReducer,
  Reconciliation: ReconciliationReducer,
  CommunicationsHub: CommunicationsHubReducer,
  CommentParsing: CommentParsingReducer
});

export type FeaturesState = ReturnType<typeof featuresReducer>;

export default featuresReducer;
